export const getGaQuestionResponses = ({questionResponses}) => {
  let formattedQuestionResponses = structuredClone(questionResponses)
  if (questionResponses.hasOwnProperty("original_lead_source")) {
    delete formattedQuestionResponses["original_lead_source"]
  }
  if (questionResponses.hasOwnProperty("paid_media_click_id")) {
    delete formattedQuestionResponses["paid_media_click_id"]
  }
  if (questionResponses.hasOwnProperty("paid_media_click_id_source")) {
    delete formattedQuestionResponses["paid_media_click_id_source"]
  }
  return formattedQuestionResponses    
}
export const sendGaFormData = ({ event = "form_submit", formData, window }) => {
  window.dataLayer = window.dataLayer || []
  if (formData) {
    let questionResponses = formData.questionResponses
    if (formData.customFields && !questionResponses) {
      questionResponses = getGaQuestionResponses({questionResponses: formData.customFields})
    }
    window.dataLayer.push({
      event,
      formData: {
        first_name: formData.first_name || formData.firstName,
        last_name: formData.last_name || formData.lastName,
        email: formData.email,
        phone_cell: formData.phone_cell || formData.phone,
        question_responses: questionResponses && Object.keys(questionResponses)?.length > 0 ? questionResponses: undefined,
      },
    })
  }
}

export const sendGaCalendlyData = ({
  event = "calendly_event",
  data,
  window,
}) => {
  window.dataLayer = window.dataLayer || []
  const calendlyActions = [
    "calendly.profile_page_viewed",
    "calendly.event_type_viewed",
    "calendly.date_and_time_selected",
    "calendly.event_scheduled",
  ]
  if (data && calendlyActions.includes(data.event)) {
    const calendlyEventName = data.event.split(".")[1]
    window.dataLayer.push({
      event,
      calendly_event_name: calendlyEventName,
      calendly_payload: data.payload,
    })
  }
}
function gtag() {
  dataLayer.push(arguments)
}

/* -------------------------------------------------------------------------- */
/*                                   Consent                                  */
/* -------------------------------------------------------------------------- */
export const essentialConsentTypes = ["analytics_storage"]
export const nonEssentialConsentTypes = {
  marketing: ["ad_storage", "ad_user_data", "ad_personalization"],
}
const allConsentTypes = essentialConsentTypes.concat(
  nonEssentialConsentTypes.marketing,
)
export const grantGaConsent = ({
  consentTypes,
  consentState = "update",
  window,
}) => {
  let consentObject = {}
  for (const consentType of allConsentTypes) {
    consentObject[consentType] =
      essentialConsentTypes.includes(consentType) ||
      consentTypes?.includes(consentType)
        ? "granted"
        : "denied"
  }

  window.dataLayer = window.dataLayer || []
  gtag("consent", consentState, consentObject)

  // Inform GTM that consent has changed
  window.dataLayer.push({ event: "consent_update" })
}
